var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._b({attrs:{"type":_vm.inputType,"placeholder":_vm.placeholder,"autocomplete":"off","autocapitalize":"off","autocorrect":"off","maxlength":"50"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.onInput($event)}}},'input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }